import  {getAttachments, getConsultationById} from '../services/Api'
import React, { useState, useEffect } from "react";
import Empty from './Empty';
import Loading from './LoadingIndicator';
import calendar from '../assets/images/calendar_icon.svg';
import document from '../assets/images/document_icon.svg';
import jpge from '../assets/images/jpge_icon.svg';
import pdf from '../assets/images/pdf_icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faGreaterThan } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';

function Attachment(props){
  const data = props.data;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" }
    return new Date(dateString).toLocaleDateString(undefined, options)
  };
  const icon = (format) => {
    if (format.includes('pdf')) {
      return pdf;
    }

    if (format.includes('jpeg')) {
      return jpge;
    }

    if (data.isConsultation) {
      return calendar;
    }
        

    return document;    
  };

  const seeDetails = () => {    
    props.setChildAttachments(data.files);
    props.setConsultation(data);
    props.setDetails(true);
  };


  return(
    <div>
      <div className='record col-4 col-s-12'>
      {data.isConsultation ? (
         <div className='attchment-element' onClick={seeDetails}>            
          <div className='info'>
            <div className='container'>
              <div className='box'>
                <img src={icon('')} alt="Logo" className='icon-attchment'/>
              </div>

              <div className='box min-width-folder'>
                <div className='attchment-title' > {formatDate(data.created_at)} </div>
                <div className='attchment-type' > {data.doctor} </div>
                <div className='attchment-date'> 
                  {data.cause}
                </div>
              </div>

             
              <div className='greater'>
                <FontAwesomeIcon icon={faGreaterThan} />
              </div>
             

            </div>
          </div>
         </div> 
      )
      : (
        <a href={data.attachment_file_url} target="_blank" rel="noopener noreferrer">
          <div className='attchment-element'>
            
            <div className='info'>
              <div className='container'>
                <div className='box'>
                  <img src={icon(data.attachment_content_type)} alt="Logo" className='icon-attchment'/>
                </div>

                <div className='box min-width'>
                  <div className='attchment-title' > {data.attachment_file_name_alias} </div>
                  <div className='attchment-type' > {data.attachment_content_type} </div>
                  <div className='attchment-date'> 
                    {formatDate(data.created_at)}
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </a>
      )}
      
      

      <style jsx="true" >{`

        .container {
          display: flex; 
          justify-content: space-around;
          margin-top: 15px;
          margin-bottom: 9px;
          margin-left: -10px;
        }

        .box {
          flex: 1;
          text-align: center;
          width: 70%;
          margin-bottom: 4px;
        }

        .min-width {
          min-width 155px;
        }

        .min-width-folder {
          min-width 160px;
        }

        .box div {
           margin-bottom: 4px;      
        }

        .greater {
          font-size: 15px;
          padding-top: 17px;
          margin-right: -17px;
          color: var(--light-sky-blue);
        }

        .attchment-type{
          font-size: 10px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: left;
          color: var(--steel);
        }
        .record{
          padding-left: 0px;
        }
        .attchment-element{
          border-radius: 4px;
          border: solid 1px var(--light-sky-blue);
          background-color: var(--white);
          display: inline-flex;
          width: 100%;
          cursor: pointer;
        }
        .attchment-element:hover{
          border-radius: 7px;
          border: solid 1px #0176fe;
          background-color: rgba(142, 198, 255, 0.1);
        }
        .attchment-date{
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: var(--steel);
          text-align: left;
        }
        .attchment-title{
          font-size: 13px;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: var(--dark-blue-grey);
          text-align: left;
        }
        img{
          align-self: center;
        }
        .icon-attchment{
          width: 45px;
          height: 45px;
        }
        .info{
          align-items: left;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
        }
      `}</style>
    </div>

    </div>
    
    
  )
    

}

function Attachments(props) {
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [seeDetails, setDetails] = useState(false);
  const [childAttachments, setChildAttachments] = useState([]);
  const [consultation, setConsultation] = useState({});
  const patient = props.patient_id;
  const {t} = useTranslation();
  async function  componentDidMount() {

    let dataAtts = [];

    try {
      const response = await getAttachments(patient);
      if(response.request.status === 200){
        const attachments = response.data.attachments;
        dataAtts = response.data.attachments;
        setLoading(false);
        if(attachments.length > 0){
          setAttachments(attachments);
          setEmpty(false)
        }
        
      }
    }catch (e) {

      setLoading(false);
      console.warn("ERROR", e);
      
    }

    if (dataAtts.length > 0) {
      // prevent Object.groupBy not a function error while in test env
      let grouped = process.env.NODE_ENV !== 'test' ? 
        Object.groupBy(dataAtts, (att) => att.consultation_id) : [];
      let keys = Object.keys(grouped);
      let array = [];

      for (const e of keys) {
        if (Number(e) > 0) {
          let response = await getConsultationById(Number(e));

          if (response && response.request && response.request.status === 200) {
           array.push({
            cause: response.data.consultation.cause,
            doctor: response.data.consultation.doctor_name,
            created_at: response.data.consultation.starts_at,
            id: response.data.consultation.id,
            isConsultation: true,
            files: grouped[e].sort((a,b) => new Date(b.created_at) - new Date(a.created_at))
           });
          }
        }
      }

      if (array.length > 0) {
        if (Array.isArray(grouped['null']) && grouped['null'].length > 0) {
          array = array.concat(grouped['null']);          
        }

        array.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
        setAttachments(array);              
      }
    }
  }

  useEffect(() => {
    componentDidMount();
    // eslint-disable-next-line
  }, [] );

  const back = () => {
    setDetails(false);
    setChildAttachments([]);
    setConsultation({});
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" }
    return new Date(dateString).toLocaleDateString(undefined, options)
  };

  return (
    <React.Fragment>
      {seeDetails ? (
        <div className="attachments-container">
          <p onClick={back} className='back'><FontAwesomeIcon icon={faArrowLeft}/> {t('common.go-back')} </p>
          <hr></hr>
          <div className='data-consultation'>
            <p className='date'>{formatDate(consultation.created_at)}</p>
            <p className='doctor'>{consultation.doctor}</p>
            <p className='cause'>{consultation.cause}</p>
          </div>
          {childAttachments.map((item,index) =><Attachment data={item} key={index} ></Attachment>)}
        </div>
      )
      : (
        <div className="attachments-container">
          <Loading working={loading}/>
          <Empty empty={empty}/>
          { attachments.map((item,index) =><Attachment data={item} key={index} 
            setDetails={setDetails} setChildAttachments={setChildAttachments}
            setConsultation={setConsultation}></Attachment>)}
        </div>
      )}

      <style jsx="true" >{`
      .back {
        color: var(--deep-sky-blue);
        cursor: pointer;     
      }

      .data-consultation p {
        margin: 3px;
      }

      .date {
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: var(--dark-blue-grey);
      }

      .doctor {
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: var(--steel);
      }

      .cause {
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: var(--steel);
      }
      
      `
        }
      </style>
      
      
    </React.Fragment>
  )
}


export default Attachments